import type React from "react";
import { Box, Paper, Typography } from "@mui/material";

interface FormLayoutProps {
  title: string;
  children: React.ReactNode;
  maxWidth?: number;
  sx?: object;
}

const FormLayout: React.FC<FormLayoutProps> = ({ title, children, maxWidth = 600, sx = {} }) => {
  return (
    <Box sx={{ maxWidth, mx: "auto", mt: 4, ...sx }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>
          {title}
        </Typography>
        {children}
      </Paper>
    </Box>
  );
};

export default FormLayout;
